'use client'

import React from 'react'
import Image from 'next/image'

const Footer = () => {
  const quickLinks = [
    { label: 'Inicio', href: '/' },
    { label: 'Cumpleaños', href: '/cumpleanos' },
    { label: 'Aniversario', href: '/aniversarios' },
    { label: 'Propuesta', href: '/propuesta' },
    { label: 'La Vida es Hoy', href: '/lavidaeshoy' },
    { label: 'Vuelos Grupales', href: '/vuelos-grupales' },
    { label: 'Paquetes Combinados', href: '/paquetes-combinados' },
    { label: 'Alojamiento', href: '/opciones-alojamiento' },
    { label: 'Restaurante', href: '/restaurante' },
  ]

  const services = [
    { label: 'Vuelo Recreativo Clásico', href: '/lavidaeshoy#vuelo-clasico' },
    { label: 'Vuelo Recreativo Max', href: '/lavidaeshoy#vuelo-max' },
    { label: 'Vuelo Recreativo Pro', href: '/lavidaeshoy#vuelo-pro' },
    { label: 'Vuelo Recreativo Pro Max', href: '/lavidaeshoy#vuelo-pro-max' },
    { label: 'Paquetes de Cumpleaños', href: '/cumpleanos' },
    { label: 'Paquetes de Aniversario', href: '/aniversarios' },
    { label: 'Paquetes de Propuesta', href: '/propuesta' },
    { label: 'Vuelos para Grupos', href: '/vuelos-grupales' },
  ]

  const socialLinks = [
    { name: 'Facebook', icon: 'facebook', href: 'https://facebook.com/airloverscolombia' },
    { name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/airloverscolombia' },
    { name: 'TikTok', icon: 'tiktok', href: 'https://www.tiktok.com/@airloverscolombia' },
  ]

  return (
    <footer className="bg-black text-white relative z-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Logo y descripción */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <Image
                src="/logo-footer.webp"
                alt="Airlovers Colombia - Parapente en los Andes"
                width={360}  // Triple del tamaño original (120×3)
                height={120} // Triple del tamaño original (40×3)
                className="h-30 w-auto"  // h-10 → h-30 (triple)
              />
            </div>
            <p className="text-gray-400 mb-6">
              Más de 20 años brindando experiencias únicas de parapente en la Sabana de Bogotá. Seguridad, profesionalismo y aventura.
            </p>
            
            {/* Social links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-20 h-20 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-blue transition-colors"
                  aria-label={social.name}
                >
                  {social.icon === 'facebook' && (
                    <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  )}
                  {social.icon === 'instagram' && (
                    <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  )}
                  {social.icon === 'tiktok' && (
                    <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                    </svg>
                  )}
                  {social.icon === 'youtube' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                  )}
                  {social.icon === 'whatsapp' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
                    </svg>
                  )}
                </a>
              ))}
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="text-lg font-heading font-bold mb-6">Enlaces rápidos</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h3 className="text-lg font-heading font-bold mb-6">Servicios</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.label}>
                  <a
                    href={service.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {service.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-lg font-heading font-bold mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-center">
                <svg className="w-5 h-5 text-primary-green mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+573028309637" className="text-gray-400 hover:text-white">
                  +57 302 830 9637
                </a>
              </li>
              <li className="flex items-center">
                <svg className="w-5 h-5 text-primary-blue mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:info@airlovers.org" className="text-gray-400 hover:text-white">
                  info@airlovers.org
                </a>
              </li>
              <li className="flex items-center">
                <svg className="w-5 h-5 text-green-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                <a href="https://wa.me/573028309637" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                  WhatsApp: +57 302 830 9637
                </a>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-primary-blue mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <a href="/como-llegar" className="text-gray-400 hover:text-white">
                  Ver ubicación y cómo llegar
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Airlovers Colombia. Todos los derechos reservados.
            </div>
            <div className="flex flex-wrap space-x-6">
              <a href="/terminos-y-condiciones" className="text-gray-400 hover:text-white text-sm">
                Términos y condiciones
              </a>
              <a href="/politica-de-privacidad" className="text-gray-400 hover:text-white text-sm">
                Política de privacidad
              </a>
              <a href="/politica-de-cookies" className="text-gray-400 hover:text-white text-sm">
                Política de cookies
              </a>
              <button
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    localStorage.removeItem('airlovers_cookie_consent')
                    window.location.reload()
                  }
                }}
                className="text-gray-400 hover:text-white text-sm underline"
                title="Reabrir el panel de preferencias de cookies"
              >
                Configurar cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer